import _ from 'lodash'

class ChangeMobileModalCtrl {
    /** @ngInject */
    constructor(User, MobilePhone, ErrorCatcher) {
        this.User = User
        this.MobilePhone = MobilePhone
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.phoneRegex = this.MobilePhone.phoneRegex.all
        this.isSending = false
        this.isSubmitted = false
        this.currentState = 'state-phone-form'
        this.errorMessage = null
        this.form = {
            phoneNumber: null,
            phoneNumberIsSame: null,
            confirmId: null,
            confirmCode: null,
            confirmCodeInError: null,
        }
    }

    isSameFromCurrentNumber() {
        return this.MobilePhone.formatPhoneToPlus33(this.resolve.currentPhoneNumber) === this.MobilePhone.formatPhoneToPlus33(this.form.phoneNumber)
    }

    submitNewPhoneNumber() {
        this.isSending = true
        return this.User.saveNewPhoneNumber({ phone: this.MobilePhone.formatPhoneToPlus33(this.form.phoneNumber) }).$promise.then((response) => {
            this.currentState = 'state-confirm-form'
            this.form.confirmId = response.processId
        }).catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.errorMessage = error.data.message
            this.currentState = 'state-error'
        }).finally(() => {
            this.isSending = false
        })
    }

    confirmNewPhoneNumber() {
        this.form.confirmCodeInError = null
        this.isSending = true
        return this.User.confirmNewPhoneNumber({ id_confirmation: this.form.confirmId }, { code: this.form.confirmCode }).$promise.then((response) => {
            this.isSubmitted = true
            this.currentState = 'state-finish'
        }).catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.errorMessage = error.data.message
            if (error.data.message === 'Code invalide') {
                this.form.confirmCodeInError = this.form.confirmCode
            }
            this.currentState = 'state-error'
        }).finally(() => {
            this.isSending = false
        })
    }

    closeModal() {
        this.close({ $value: { isSubmitted: this.isSubmitted } })
    }
}

export default {
    template: require('./change-mobile-modal.jade')(),
    controller: ChangeMobileModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/personalInformation/modal/change-mobile-modal.js